import { combineMapKey, getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useGlobalStore } from './global';
import { resolvePackagePriceDisplay } from './package-price';
import { usePriceListStore } from './price-list';
export const useWheelStore = defineStore('wheel-store', {
    getters: {
        wheelList() {
            const featureList = useFeatureListStore();
            if (!featureList.data)
                return {
                    options: [],
                    optionCodes: [],
                };
            const wheelCodeList = [
                CategoryCode.Exterior,
                SubCategoryCode.Wheel,
                FeatureType.ExteriorWheel,
            ];
            const featureItem = getFeatureData(wheelCodeList, featureList.data);
            const options = featureItem?.option_list?.map((option) => featureList.data?.option_map[option]);
            return {
                options,
                optionCodes: featureItem?.option_list,
            };
        },
        currentWheelData() {
            const globalStore = useGlobalStore();
            const featureList = useFeatureListStore();
            const priceList = usePriceListStore();
            if (!featureList.data)
                return null;
            const combineData = featureList.data.option_combine_map[combineMapKey(globalStore.currentOptions.F00019, globalStore.currentOptions.F00003)];
            const colorCombinedData = featureList.data.option_combine_map[combineMapKey(globalStore.currentOptions.F00002, globalStore.currentOptions.F00003)];
            const wheelData = featureList.data.option_map[globalStore.currentOptions.F00003] ?? {};
            // 套装展示：命中 package_price_list 优先，否则保留 feature/list option 上的 package_price_desc（见 package-price.ts）
            const packagePriceDisplay = resolvePackagePriceDisplay({
                optionCode: wheelData?.code,
                price: wheelData?.price,
                packagePriceList: featureList.effectivePackagePriceList,
                optionPackagePriceDesc: wheelData?.package_price_desc,
            });
            const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[globalStore.currentOptions.F00003] || '';
            const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[globalStore.currentOptions.F00003];
            const discountData = {
                discount_selected: !!priceDiscountTip,
                discount_tip: priceDiscountTip || wheelData?.discount_tip || '',
                discount_tip_icon: priceDiscountTipIcon?.icon || wheelData?.discount_tip_icon || '',
                discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || wheelData?.discount_tip_icon_ratio || '',
            };
            return {
                ...wheelData,
                name: wheelData.name,
                wheelPrice: wheelData.price,
                wheelTipDesc: wheelData.detail_desc_url,
                wheelTitle: wheelData.name,
                wheelDesc: combineData?.desc,
                wheelExtraDesc: colorCombinedData?.price_desc || colorCombinedData?.desc,
                ...packagePriceDisplay,
                ...discountData,
            };
        },
    },
});
